import Icon from "../Components/Node_Edge Components/Stencils/Icon";
import Rectangle from "../Components/Node_Edge Components/Stencils/Rectangle";
import Oval from "../Components/Node_Edge Components/Stencils/Oval";
import Diamond from "../Components/Node_Edge Components/Stencils/Diamond";
import Parallelogram from "../Components/Node_Edge Components/Stencils/Parallelogram";
import CustomNode from "../Components/Node_Edge Components/Stencils/CustomNode";

const nodeTypes = {
    icon: Icon,
    rectangle: Rectangle,
    oval: Oval,
    diamond: Diamond,
    parallelogram: Parallelogram,
    customNode: CustomNode,
}


export default nodeTypes;

